import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { SalesDashboardScreen } from '@/features/sales-dashboard/sales-dashboard-screen'
import {
  type SalesDashboardSearch,
  salesDashboardSearchFrom,
} from '@/features/sales-dashboard/sales-search'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/sales/')({
  validateSearch: (search: Record<string, unknown>): SalesDashboardSearch =>
    salesDashboardSearchFrom(search),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'sales_order.view')) throw redirect({ to: '/' })
  },
  component: SalesOverviewRoute,
})

function SalesOverviewRoute() {
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <SalesDashboardScreen
      search={Route.useSearch()}
      onSearchChange={(next) => void navigate({ search: (prev) => ({ ...prev, ...next }) })}
    />
  )
}
